<template>
  <Row class="borrowinfo">
    <Col span="12" class="info-l">
      <Row class="borrow-m">
        <Col span="8">
          <span>{{$t('label.w111')}}</span>
          <span>{{data.RealName}}</span>
        </Col>
        <Col span="8">
          <span>{{$t('label.w112')}}</span>
          <span>{{data.LoanSchemeCount}}</span>
        </Col>
        <Col span="8">
          <span>{{$t('label.w113')}}</span>
          <span>{{data.HalfYearOverdue?$t('option.w63'):$t('option.w36')}}</span>
        </Col>
        <Col span="8">
          <span>{{$t('label.w114')}}</span>
          <span>{{data.Gender}}</span>
        </Col>
        <Col span="8">
          <span>{{$t('label.w115')}}</span>
          <span>{{data.Age}}</span>
        </Col>
        <Col span="8">
          <span>{{$t('label.w116')}}</span>
          <span>{{data.RegisterAt}}</span>
        </Col>
      </Row>
      <div class="wrap">
        <div>{{$t('title.w36')}}</div>
      </div>
      <Row class="approve" type="flex" justify="center" align="middle">
        <Col span="8" class="approve-c">
          <i class="name" :class="{'un-name':!data.IdCardVerified}"></i>
          <span>{{$t('label.w24')}}</span>
        </Col>
        <Col span="8" class="approve-c">
          <i class="phone" :class="{'un-phone':!data.MobliePhoneVerified}"></i>
          <span>{{$t('label.w117')}}</span>
        </Col>
        <Col span="8" class="approve-c">
          <i class="email" :class="{'un-email':!data.EmailVerified}"></i>
          <span>{{$t('label.w118')}}</span>
        </Col>
      </Row>
    </Col>
    <Col span="12">
      <Row type="flex" justify="space-around">
        <Col span="10" class="domain">
          <h3>{{$t('title.w37')}}</h3>
          <ul>
            <li v-for="(v,i) in chart" :key="i"><p class="text-l"><span class="s1" :style="{background:color[i]}"></span><span></span>{{v.DomainTypeName}}</span></p><P class="text-r"><span class="p1">{{v.Count}}</span></P></li>
          </ul>
        </Col>
        <Col span="14" class="chars" id="chartpie"></Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
// 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/pie");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");

export default {
  props:['data','chart','idType','state'],
  data() {
    return {
      color:[
          "#FF2712",
          "#FD520A",
          "#FB9902",
          "#FBBB02",
          "#F8E71C",
          "#D1EA2C",
          "#66B035",
          "#0C8ED0",
          "#0048FD",
          "#8601B0",
          "#E066FF"
      ]
    };
  },
  watch:{
    chart(){
      this.initchart();
    }
  },
  mounted() {
  },
  methods: {
    initchart() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("chartpie"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: `{b} <br/>${this.$t('label.w119')}{c}${this.$t('label.w5')} ，${this.$t('label.w120')}{d}%`,
        },
        title: {
          subtext: this.$t('other.w77').replace('{%}',this.data.PledgeCount).replace('{%}',this.data.CreditTotalAmount),
          subtextStyle: {
            fontSize: 14,
            color: "#7B7B7C"
          },
          x:'center',
          y:'340px'
        },
        // legend: {
        //   orient: "vertical",
        //   x: "30px",
        //   y: "60px",
        //   itemWidth: 10,   // 设置图例图形的宽
        //   itemHeight: 8,  // 设置图例图形的高
        //   textStyle: {
        //       color: '#7B7B7C'  // 图例文字颜色
        //     },
        //     // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
        //     itemGap: 25,
        //   data: this.chart.map(v=>v.DomainTypeName)
        // },
        color: this.color,
        series: [
          {
            type: "pie",
            name: this.$t('label.w121'),
            radius: ["30%", "60%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
                formatter: '{b} \n {d}%'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold",
                  color: "#232325"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data:this.chart.map(v=>{
              return {
                value:v.CreditAmount,
                name:v.DomainTypeName
              }
            })
            // data: [
            //   { value: 2, name: "单声母.com" },
            //   { value: 5, name: "双声母.com" },
            //   { value: 15, name: "三声母.com" },
            //   { value: 10, name: "四声母.com" },
            //   { value: 45, name: "五声母.com" },
            //   { value: 58, name: "单数字无04.cn" },
            //   { value: 69, name: "双数字无04" },
            //   { value: 77, name: "三数字无04.cn" },
            //   { value: 53, name: "四数字无04.cn" },
            //   { value: 89, name: "五数字无04.cn" }
            // ]
          }
        ]
      });
    }
  }
};
</script>

<style lang="less">
.borrowinfo {
    height: 402px;
  .info-l {
    height: 100%;
    border-right: 1px solid #f0f1f9;
    .borrow-m {
      height: 180px;
      padding-left: 30px;
      span {
        display: inline-block;
        padding-top: 40px;
        color: #7b7b7c;
        font-size: 14px;
      }
      span:last-child {
        color: #232325;
        font-weight: 500;
        margin-left: 10px;
      }
    }
    .wrap {
      position: relative;
      text-align: left;
      padding-left: 25px;
      width: 100%;
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      div {
        line-height: 20px;
      }
      div:after,
      div:before {
        position: absolute;
        top: 50%;
        background: #f0f1f9;
        content: "";
        height: 1px;
      }
      div:before {
        left: 0;
        width: 20px;
      }
      div:after {
        right: 0;
        width: 472px;
      }
    }
    .approve {
      height: 200px;
      text-align: center;
      font-size: 14px;
      color: #232325;
      .approve-c {
        i {
          display: inline-block;
          width: 62px;
          height: 62px;
          background: url("../../../assets/borrow/pic_state@2x.png") no-repeat;
          background-size: 188px 125px;
          background-position: 0 0px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .un-name {
          background-position: 0 -62px;
        }
        .phone {
          background-position: -64px 0;
        }
        .un-phone {
          background-position: -64px -64px;
        }
        .email {
          background-position: -126px 0;
        }
        .un-email {
          background-position: -126px -64px;
        }
      }
    }
  }
  .chars {
    height: 400px;
  }
  .domain {
    border-right: 1px solid #F0F1F9;
    padding-left: 30px;
    h3{
      margin: 20px 0 30px 0;
      font-size: 14px;
      color: #232325;
    }
    ul>li{
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 13px;
      .text-l {
        width: 70%;
        .s1{
          display: inline-block;
          width: 10px;
          height: 8px;
          margin-right: 5px;
        }
      }
      .text-r{
        width: 30%;
        .p1{
           display: inline-block;
            height:16px;
            width: 32px;
            line-height: 16px;
            text-align: center;
            color: #fff;
            background:rgba(255,162,162,1);
            border-radius:8px;
            border:1px solid rgba(255,139,139,1);
        }
      }
    }
  }
}
</style>